import { Loader } from "@tql/ui-components-react/kendo/indicators";
import {
	NumericTextBox,
	RadioButton,
} from "@tql/ui-components-react/kendo/inputs";
import { Button } from "@tql/ui-components-react/tql/buttons";

import type { QuoteStateType } from "~/shared/types/quote-details-types.ts";

type MarginAdjustmentProps = {
	handleAdjustClick: (quoteState: QuoteStateType) => void;
	handleMarginTypeChange: (type: "percentage" | "flat") => void;
	isAdjustingPrices: boolean;
	marginType: "percentage" | "flat";
	marginValue: number;
	quoteState: QuoteStateType;
	setMarginValue: (value: number) => void;
};

export const MarginAdjustment = ({
	handleAdjustClick,
	handleMarginTypeChange,
	isAdjustingPrices,
	marginType,
	marginValue,
	quoteState,
	setMarginValue,
}: Readonly<MarginAdjustmentProps>) => {
	return (
		<div className={"margin-adjustment"}>
			<div className={"adjust-title"}>Adjust Margins</div>
			<div className={"margin-adjustment-controls"}>
				<div>
					<NumericTextBox
						format={marginType === "percentage" ? "p" : "c2"}
						min={0}
						onChange={(e) => {
							const cleanVal = Math.abs(e.target.value ?? 0);
							setMarginValue(cleanVal);
						}}
						placeholder={marginType === "percentage" ? "0%" : "$0.00"}
						spinners={false}
						style={{ width: 80 }}
						value={marginValue}
					/>
				</div>
				<div>
					<div>
						<RadioButton
							checked={marginType === "percentage"}
							label={"Percentage"}
							name={"marginType"}
							onChange={() => handleMarginTypeChange("percentage")}
							value={"percentage"}
						/>
					</div>
					<div>
						<RadioButton
							checked={marginType === "flat"}
							label={"Flat"}
							name={"marginType"}
							onChange={() => handleMarginTypeChange("flat")}
							value={"flat"}
						/>
					</div>
				</div>
				<div className={"adjust-button"}>
					<Button
						disabled={isAdjustingPrices}
						onClick={() => handleAdjustClick(quoteState)}
					>
						{isAdjustingPrices ? <Loader size={"small"} /> : "Adjust"}
					</Button>
				</div>
			</div>
		</div>
	);
};
